import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import moment from "moment-jalaali";
import { useTerminals } from "features/terminals/api/get-terminals";
import { useQueries, UseQueryResult } from "react-query";
import { transaction, TransactionDTO } from "features/transactions-list/type";
import { getTransactions } from "features/transactions-list/api/get-transactions";
import { TransactionsBarChart } from "./transactions-bar-chart";
import { TransactionsLineChart } from "./transactions-line-chart";

import styles from "./index.module.scss";
import { CalendarDateFill } from "react-bootstrap-icons";
interface accumulatedAmountTr extends transaction {
  accumulatedAmount: number;
}
export const Dashboard = () => {
  const [tr, setTr] = useState<accumulatedAmountTr[] | null>(null);
  const fromDate = moment(new Date()).format("YYYY-MM-DD");
  const toDate = moment(new Date()).format("YYYY-MM-DD");

  const today = new Date();
  const terminalQuery = useTerminals({
    PageSize: 5000,
    PageNumber: 1,
  });
  const transactionsQueries: {
    terminalId?: number;
    query: UseQueryResult<TransactionDTO, unknown>;
  }[] = useQueries(
    terminalQuery.isSuccess
      ? terminalQuery.data.data?.map((terminal) => {
          return {
            queryKey: ["transactions", terminal.id],
            queryFn: () =>
              getTransactions({
                TerminalId: terminal.id,
                PageNumber: 1,
                PageSize: 5000,
                FromDate: fromDate,
                ToDate: toDate,
              }),
            enabled: !!terminal.id,
          };
        })
      : []
  ).map((query, index) => ({
    terminalId: terminalQuery.data?.data[index].id,
    query: query,
  }));
  useEffect(() => {
    transactionsQueries?.forEach((transaction, index) => {
      if (transaction.query.data?.data) {
        const successTransactions = transaction.query.data.data
          .filter(
            ({ status, responseCode }) =>
              status === "220" && responseCode === "00"
          )
          .sort((a, b) => moment(a.date_2).diff(moment(b.date_2)));
        let accumulatedAmount = 0;
        setTr(
          successTransactions.map((transaction) => {
            if (
              transaction.responseCode === "00" &&
              transaction.status === "220"
            ) {
              accumulatedAmount += transaction.amount;
            }

            return {
              ...transaction,
              accumulatedAmount: accumulatedAmount,
            };
          })
        );
      }
    });
  }, [transactionsQueries]);
  return (
    <>
      <Row>
        {transactionsQueries.some((item) => item.query.isFetching) ? (
          <div className="custom-box w-100 flex-center" style={{height:"80vh"}}>
            <Spinner />
          </div>
        ) : (
          <>
            <Col md={8} className="custom-box flex-center">
              {
                <TransactionsLineChart
                  startDate={fromDate}
                  endDate={toDate}
                  transactions={transactionsQueries}
                  isLoading={transactionsQueries.some(
                    (item) => item.query.isFetching
                  )}
                />
              }
            </Col>
            <Col md={4} className="d-flex flex-grow-1">
              <Row className="gap-4 d-flex flex-column flex-grow-1">
                <Col md={12} className={styles.bar_chart_container}>
                  {transactionsQueries.map((item, index) => {
                    return (
                      <TransactionsBarChart
                        key={index}
                        isLoading={transactionsQueries.some(
                          (item) => item.query.isFetching
                        )}
                        terminalId={item.terminalId}
                        successTransactions={
                          item.query.data?.totalSuccessTransaction
                        }
                        totalRecords={item.query.data?.totalRecord}
                      />
                    );
                  })}
                </Col>
                <Col md={12} className=" d-flex flex-grow-1 ">
                  <div className="custom-box w-100">
                    <div className=" py-4 px-1">
                      <span className="stroke-color">
                        <CalendarDateFill className="ms-2 my-2"/>
                        {today.toLocaleDateString("fa-IR", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                        })}
                      </span>
                      <h2> مبلغ کل تراکنش های موفق:</h2>
                      <h1 className="text-success text-start" style={{fontSize:33}}>
                        {tr &&
                          tr[
                            tr?.length - 1
                          ]?.accumulatedAmount.toLocaleString()}{" "}
                        ریال
                      </h1>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};
